/**
 * 页面三态里的「失败」态。
 *
 * 服务方是外部机构，他们看到的报错要能自己判断下一步：
 * 401（会话失效 → 重新登录）、403（账号/主体状态问题 → 联系平台运营）、
 * 409（状态流转不合法 → 刷新后按当前状态操作）必须分开，不能都是一个「出错了」。
 */
import type { ReactNode } from 'react';
import { ApiError } from '../lib/api.ts';

export function ErrorBox({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="state-box error">
      <div className="st-ico">⚠</div>
      <div className="st-title">{message}</div>
      {onRetry !== undefined && (
        <button type="button" className="btn sm" onClick={onRetry}>
          重试
        </button>
      )}
    </div>
  );
}

/** 请求失败的统一文案：ApiError 带服务端 message，其余给通用提示。 */
export function errorText(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  if (err instanceof Error) return err.message;
  return '请求失败，请稍后重试';
}

export function LoadingBox({ text = '正在加载…' }: { text?: string }): ReactNode {
  return (
    <div className="state-box">
      <div className="spinner" />
      <div>{text}</div>
    </div>
  );
}

export function EmptyBox({ title, desc }: { title: string; desc?: string }) {
  return (
    <div className="state-box">
      <div className="st-ico">◍</div>
      <div className="st-title">{title}</div>
      {desc !== undefined && <div>{desc}</div>}
    </div>
  );
}
